import { CACHE_TIERS } from "@workspace/types";
import { trpc } from "@/lib/trpc/react";
import type { ShowFiltersData } from "@/server/api/routers/show/filters";

interface UseShowFiltersDataParams {
	city?: string;
	venueId?: string;
	genres?: string[];
	startDate?: string | null;
	endDate?: string | null;
}

/**
 * tRPC-enabled hook for fetching available show filters with cascading filter support
 * This fetches the actual filter data from the server (venues, locations, genres)
 * Filter options are dynamically filtered based on other active filters
 */
export function useShowFiltersData(params?: UseShowFiltersDataParams) {
	// Normalize "all" values to undefined for API
	const normalizedParams = params
		? {
				city: params.city === "all" ? undefined : params.city,
				venueId: params.venueId === "all" ? undefined : params.venueId,
				genres: params.genres && params.genres.length > 0 ? params.genres : undefined,
				startDate: params.startDate ?? undefined,
				endDate: params.endDate ?? undefined,
			}
		: {};

	return trpc.show.getFilters.useQuery(normalizedParams, {
		...CACHE_TIERS.STATIC, // Static content - filter options rarely change
		placeholderData: (previousData) => previousData, // Keep previous data during refetch
	}) as unknown as {
		data: ShowFiltersData | undefined;
		isLoading: boolean;
		error: unknown;
	};
}
